export default "__VITE_ASSET__47563f89__"